import { Injectable } from '@angular/core';
import { IncomingRequestInterface } from 'models/requests.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RequestsService {

  public _requests: Array<IncomingRequestInterface>;
  public working_spinner: boolean = false;

  public currentTotalRequests: number = 0;
  public currentTotalBlockedRequests: number = 0;

  constructor(private http: HttpClient) {
    this._requests = [];
  }

  get blockedRequestCount(): number {
    return this.currentTotalBlockedRequests ? this.currentTotalBlockedRequests : 0;
  }

  get requestCount(): number {
    return this._requests ? this._requests.length : 0;
  }

  public async getTotalRequests(hostname: string) { 
    const GET_TOTAL_REQUESTS: string = `https://us-central1-relayclients.cloudfunctions.net/getTotalRequests?hostname=${hostname}`;
    this.working_spinner = true;
    console.log(`Querying API for requests ${GET_TOTAL_REQUESTS}`);
    const totalRequestsResponse: any = await this.http.get(GET_TOTAL_REQUESTS).toPromise();
    
    
    console.log(totalRequestsResponse);
    if (totalRequestsResponse && totalRequestsResponse.requests) {
      this.currentTotalRequests = totalRequestsResponse.requests;
    } else {
      this.currentTotalRequests = 0;
    }

    if (totalRequestsResponse && totalRequestsResponse.blocked) {
      this.currentTotalBlockedRequests = totalRequestsResponse.blocked;
    } else {
      this.currentTotalBlockedRequests = 0;
    }
    
    this.working_spinner = false;
  }

  public async getRequests(hostname: string) { 
    const GET_REQUESTS_URL: string = `https://us-central1-relayclients.cloudfunctions.net/getRequestsForHost?hostname=${hostname}`;
    this.working_spinner = true;
    console.log(`Querying API for requests ${GET_REQUESTS_URL}`);
    const requestsResponse: any = await this.http.get(GET_REQUESTS_URL).toPromise();
    
    this._requests = [];
    for (const key in requestsResponse) {
      if (requestsResponse.hasOwnProperty(key)) {
        const request: IncomingRequestInterface = requestsResponse[key];
        this._requests.push(request);
      }
    }

    //Latest entries first friend
    this._requests = this._requests.reverse();
    
    console.log(this._requests);
    
    
    this.working_spinner = false;
  }
}
